import { Accordion, Header } from '@mairistem/composants';
import { Icon } from '@mairistem/finances-utils';
import React from 'react';
import type BaseControleCoherence from '../../../../classes/outils/ControleCoherence/BaseControleCoherence';
import FamilleControleCoherence from '../../../../constants/simulation/familleControleCoherence';
import type TypeBudget from '../../../../constants/simulation/typeBudget';
import ControleCoherenceItem from './ControleCoherenceItem';
import './ControleCoherenceList.css';

interface ControleCoherenceListProps {
	controlesList: BaseControleCoherence[][];
	typeBudget: TypeBudget;
}

const ControleCoherenceList = ({
	controlesList,
	typeBudget,
}: ControleCoherenceListProps) => {
	const [accordionsActive, setAccordionsActive] = React.useState({
		[FamilleControleCoherence.EQUILIBRE_BUDGETAIRE]: true,
		[FamilleControleCoherence.OPERATIONS_ORDRE]: true,
		[FamilleControleCoherence.AUTRES]: true,
	});

	const handleAccordionsActive = (famille: FamilleControleCoherence) => {
		setAccordionsActive((old) => ({
			...old,
			[famille]: !old[famille],
		}));
	};

	return controlesList.map((controles) => {
		const { famille } = controles[0];
		const active = accordionsActive[famille];

		return (
			<Accordion className="accordionControleCoherence" key={famille}>
				<Accordion.Title
					active={active}
					onClick={() => handleAccordionsActive(famille)}
				>
					<Icon
						color="#004a99"
						iconSet="Lucide"
						name={accordionsActive[famille] ? 'ChevronDown' : 'ChevronRight'}
						strokeWidth={3}
					/>
					<Header size="small">{controles[0].getFamille()}</Header>
				</Accordion.Title>
				<Accordion.Content active={active}>
					{controles.map((controle, i) => (
						<ControleCoherenceItem
							controle={controle}
							// biome-ignore lint/suspicious/noArrayIndexKey: Pas d'autres choix
							key={i}
							typeBudget={typeBudget}
						/>
					))}
				</Accordion.Content>
			</Accordion>
		);
	});
};

export default ControleCoherenceList;
